import { QueryPageBase } from "./../queryPageBase";
//-查询参数
export class QueryForm extends QueryPageBase {
  typeName: string = "";
  beginTime: string = "";
  endTime: string = "";
}
//查询结果数据格式
export class GetByPageData {
  tableData: GetByPageDataDetail[];
  total: number = 0;
}
//-查询结果数据格式-数据部分
export class GetByPageDataDetail {
  typeName: string = "";
  backPicPath: string = "";
  createUserId: string = "";
  createTime: string = "";
  isDelete: boolean = false;
  sort = 1;
  id: string = null;
}
// 获取stsToken参数
export class GetStsParam {
  ossType: number = 0; // 上传0 下载1
}
// 上传文件到oss类
export class UploadClass {
  region: string = "oss-cn-beijing";
  accessKeyId: string = "";
  accessKeySecret: string = "";
  bucket: string = process.env.Bucket;
  stsToken: string = "";
}
//-新增数据格式-数据部分
export class AddDataDetail {
  typeName: string = "";
  backPicPath: string = "";
  // createTime: string = "";
  // isDelete: boolean = false;
  reUploadPic: boolean = false;
  sort = 1;
  id: string = null;
}
